import { render, staticRenderFns } from "./InvoicePayments.vue?vue&type=template&id=8d8874b8&scoped=true&"
import script from "./InvoicePayments.vue?vue&type=script&lang=ts&"
export * from "./InvoicePayments.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicePayments.vue?vue&type=style&index=0&id=8d8874b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8874b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
